import React from 'react';
import { TrendingDown, Globe, Shield, ArrowRight } from 'lucide-react';

const IndigenousFinancialRail = () => {
  return (
    <section className="bg-gradient-to-b from-black via-gray-900 to-black py-24 relative overflow-hidden" data-testid="what-is-hiko">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 relative z-10">
        {/* Three pillars of Hiko */}
        <div className="grid lg:grid-cols-3 gap-6 mb-16">
          <div className="bg-white/[0.03] border border-cyan-400/20 p-10">
            <div className="w-14 h-14 bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center mb-6">
              <Globe size={26} className="text-cyan-300" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Closed-loop intermediation</h3>
            <p className="text-white/70 mb-6 leading-relaxed">
              <span className="text-cyan-300">Hiko</span> is the rail. Funds enter and leave the loop in NZD through existing bank rails. Inside
              the loop, instructions settle in real time between a counterparty, its verified members,
              and whitelisted merchants.
            </p>
            <ul className="space-y-3 text-sm text-white/65">
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Bypasses the offshore card-network layer</li>
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Real-time settlement between enrolled parties</li>
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Integrates with existing POS &amp; bank accounts</li>
            </ul>
          </div>

          <div className="bg-white/[0.03] border border-cyan-400/20 p-10">
            <div className="w-14 h-14 bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center mb-6">
              <TrendingDown size={26} className="text-cyan-300" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Lower cost by design</h3>
            <p className="text-white/70 mb-6 leading-relaxed">
              By removing intermediaries, <span className="text-cyan-300">Hiko</span> lowers payment costs and keeps more value inside Iwi
              and community economies.
            </p>
            <ul className="space-y-3 text-sm text-white/65">
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />No card-network interchange</li>
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Faster disbursements with less wastage</li>
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Predictable, transparent fee structure</li>
            </ul>
          </div>

          <div className="bg-white/[0.03] border border-cyan-400/20 p-10">
            <div className="w-14 h-14 bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center mb-6">
              <Shield size={26} className="text-cyan-300" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Māori-governed &amp; regulator-engaged</h3>
            <p className="text-white/70 mb-6 leading-relaxed">
              Scheme parameters sit with the Māori Fintech. With FSP accreditation &amp; AML/CFT
              compliance for Phase 1.
            </p>
            <ul className="space-y-3 text-sm text-white/65">
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Te Mana Raraunga data principles</li>
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Compliance reporting under our regulatory obligations</li>
              <li className="flex items-start gap-2"><ArrowRight size={16} className="text-cyan-300 mt-1 flex-shrink-0" />Joint engagement with RBNZ before scaling</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-400/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-400/5 rounded-full blur-3xl" />
    </section>
  );
};

export default IndigenousFinancialRail;
